@if (isVisible && prod && enableSEO) {
  <div
    class="text-neon w-full py-10 fixed bottom-0 left-0 right-0 bg-night border-t-solid border-t border-neon rounded-t-sm min-h-[100px] z-[100]">
    <div
      class="page-content-padding page-content-max-width w-full gap-8 flex flex-col lg:flex-row justify-between items-center flex-wrap">
      <p class="flex-[2_2_0] text-justify">{{ 'cookies_desc' | translate }}</p>

      <div class="flex flex-1 gap-8 uppercase justify-start md:justify-end">
        <k-button
          [color]="buttonColors.Neon"
          [outlined]="true"
          (click)="declineCookies()">
          {{ 'decline' | translate }}
        </k-button>
        <k-button
          [color]="buttonColors.Neon"
          (click)="acceptCookies()">
          {{ 'accept' | translate }}
        </k-button>
      </div>
    </div>
  </div>
}
